/** Handle Screen Wake Lock API (совместимость со старыми DOM-типами TS) */
export type WakeLockSentinel = {
  readonly released: boolean
  readonly type: 'screen'
  release: () => Promise<void>
}

type NavigatorWithWakeLock = Navigator & {
  wakeLock?: {
    request: (type: 'screen') => Promise<WakeLockSentinel>
  }
}

/**
 * Запрашивает Screen Wake Lock (если API доступен и вкладка видима).
 * @returns WakeLockSentinel или null при недоступности / ошибке
 */
export const acquireScreenWakeLock = async (): Promise<WakeLockSentinel | null> => {
  try {
    const navigatorWithWakeLock = navigator as NavigatorWithWakeLock

    if (!navigatorWithWakeLock?.wakeLock?.request) {
      return null
    }

    if (document.visibilityState !== 'visible') {
      return null
    }

    return await navigatorWithWakeLock.wakeLock.request('screen')
  } catch {
    return null
  }
}
